module.exports = __webpack_public_path__ + "static/img/img_pic_big@2x.1776169966151.png";